// Single lookup from the string icon names used in lib/stage.ts (which must
// stay free of React imports for testability) to lucide components.
import { createElement, type CSSProperties } from 'react'
import {
  Antenna,
  Bot,
  BotMessageSquare,
  Bug,
  Building2,
  Calendar,
  CalendarRange,
  ChartLine,
  Circle,
  CircleCheck,
  CircleDashed,
  CircleDot,
  Clock,
  DatabaseBackup,
  DatabaseZap,
  Eye,
  Flame,
  GitMerge,
  HeartPulse,
  Hourglass,
  Inbox,
  InboxIcon,
  IterationCw,
  LifeBuoy,
  Map as MapIcon,
  OctagonAlert,
  Package,
  PackageCheck,
  Rocket,
  ShieldCheck,
  Siren,
  Sparkle,
  SquareCheck,
  TimerOff,
  UserRound,
  UserRoundCheck,
  Users,
  UsersRound,
  type LucideIcon,
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
  antenna: Antenna,
  bot: Bot,
  'bot-message-square': BotMessageSquare,
  bug: Bug,
  'building-2': Building2,
  calendar: Calendar,
  'calendar-range': CalendarRange,
  'chart-line': ChartLine,
  circle: Circle,
  'circle-check': CircleCheck,
  'circle-dashed': CircleDashed,
  'circle-dot': CircleDot,
  clock: Clock,
  'database-backup': DatabaseBackup,
  'database-zap': DatabaseZap,
  eye: Eye,
  flame: Flame,
  'git-merge': GitMerge,
  'heart-pulse': HeartPulse,
  hourglass: Hourglass,
  inbox: Inbox,
  'inbox-icon': InboxIcon,
  'iteration-cw': IterationCw,
  'life-buoy': LifeBuoy,
  map: MapIcon,
  'octagon-alert': OctagonAlert,
  package: Package,
  'package-check': PackageCheck,
  rocket: Rocket,
  'shield-check': ShieldCheck,
  siren: Siren,
  sparkle: Sparkle,
  'square-check': SquareCheck,
  'timer-off': TimerOff,
  'user-round': UserRound,
  'user-round-check': UserRoundCheck,
  users: Users,
  'users-round': UsersRound,
}

function iconByName(name: string | undefined): LucideIcon {
  return (name && ICONS[name]) || Circle
}

/** Renders a lucide icon from its kebab-case registry name. */
export function AppIcon({
  name,
  className,
  style,
}: {
  name: string | undefined
  className?: string
  style?: CSSProperties
}) {
  return createElement(iconByName(name), { className, style })
}
